import React from "react";
import PlanningStatusEnum from "../../../Enums/PlanningStatusEnum";
import dateTimeHelper from "../../../Helpers/datetimeHelper";
import stringHelper from "../../../Helpers/stringHelper";
import userHelper from "../../../Helpers/userHelper";
import PlanningDetailsItemService from "../../../Services/PlanningDetailsItemService";
import ColButton from "../../../Elements/ColButton";
import OverWindow from "../../../Elements/OverWindow";
import ErrorMessage from "../../../Elements/ErrorMessage";
import ButtonFooterContainer from "../../../Elements/ButtonFooterContainer";

class PlanningDetailItemStatusUpdateBox extends React.Component {
  constructor(props) {
    super(props);

    this.clickOnSubmit = this.clickOnSubmit.bind(this);
  }

  renderButton(statusId) {
    let clickhandler = () => this.clickOnSubmit(statusId);
    if (statusId === PlanningStatusEnum.Closed || statusId === PlanningStatusEnum.Cancelled) {
      clickhandler = () => ErrorMessage.SetApprove("You won't be able to go back. Are you sure?", () => this.clickOnSubmit(statusId));
    }
    return (
      <div
        className="col"
        key={`key${statusId}`}
      >
        <ColButton
          text={`to ${stringHelper.convertToWords(statusId)}`}
          onClick={clickhandler}
        />
      </div>
    );
  }

  clickOnSubmit(newStatus) {
    const editedItem = this.props.selectedItem;
    editedItem.Status = newStatus;
    PlanningDetailsItemService.EditPlanningDetailsItem(editedItem)
      .then(() => this.props.submitHandler())
      .catch(() => ErrorMessage.SetErrorMessage("PDISUB43"));
  }

  renderCreatedOrClientConfirmedButton() {
    if (this.props.selectedItem.NumberOfPlannedAssignments === 0 || dateTimeHelper.toYYYYsMMsDD(this.props.selectedItem.StartDate) <= dateTimeHelper.toYYYYsMMsDD(new Date())) {
      return this.renderButton(PlanningStatusEnum.Created);
    } else {
      return this.renderButton(PlanningStatusEnum.ClientConfirmed);
    }
  }

  renderNewStatusButtons() {
    const buttons = [];

    switch (this.props.selectedItem.Status) {
      case PlanningStatusEnum.Created:
        buttons.push(this.renderButton(PlanningStatusEnum.OnHold));
        buttons.push(this.renderButton(PlanningStatusEnum.Cancelled));
        break;
      case PlanningStatusEnum.ClientConfirmed:
        buttons.push(this.renderButton(PlanningStatusEnum.Closed));
        buttons.push(this.renderButton(PlanningStatusEnum.OnHold));
        buttons.push(this.renderButton(PlanningStatusEnum.Cancelled));
        break;
      case PlanningStatusEnum.Closed:
        if (userHelper.isAdmin()) {
          buttons.push(
            <div
              className="border rounded m-1 p-1 text-center"
              key="nyugitamas"
            >
              Nyugi, Tamás!
              <br />
              Csak az adminok tudnak Closed státuszt OnHoldra tenni!
              <br />
              <img
                src="/img/user/vecseitamas-small.jpg"
                alt=""
              />
            </div>
          );
          buttons.push(this.renderButton(PlanningStatusEnum.OnHold));
        }
        break;
      case PlanningStatusEnum.OnHold:
        buttons.push(this.renderCreatedOrClientConfirmedButton());
        buttons.push(this.renderButton(PlanningStatusEnum.Cancelled));
        break;
      case PlanningStatusEnum.Cancelled:
        buttons.push(this.renderCreatedOrClientConfirmedButton());
        buttons.push(this.renderButton(PlanningStatusEnum.OnHold));
        break;

      default:
        break;
    }

    return <ButtonFooterContainer>{buttons.length > 0 ? buttons : "The status of this PlanningDetail can't be changed."}</ButtonFooterContainer>;
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.cancelHandler}
        title={this.props.caption}
        closeOnClickOutside={false}
      >
        <div className="form-group container-fluid">
          <div>
            <h6>
              Id: {this.props.selectedItem.PlanningDetailId}, Fieldwork Period: {this.props.selectedItem.FieldworkOrderNumber}, {dateTimeHelper.toYYYYsMMsDD(this.props.selectedItem.StartDate)} -{" "}
              {dateTimeHelper.toYYYYsMMsDD(this.props.selectedItem.EndDate)}
            </h6>
            <h6>
              Actual status: <span className="badge badge-primary">{stringHelper.convertToWords(this.props.selectedItem.Status)}</span>
            </h6>
            <p>Click on one of the following buttons to change the status of this item.</p>
          </div>
          {this.renderNewStatusButtons()}
        </div>
      </OverWindow>
    );
  }
}

export default PlanningDetailItemStatusUpdateBox;
